import React, { Component } from 'react';
import MaterialTable from 'material-table';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import SystemUpdateAltSharpIcon from '@material-ui/icons/SystemUpdateAltSharp';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

import Grid from "@material-ui/core/Grid";
import { ProjectData } from "../components/ProjectData";
import { ProjectKeyInformation } from "../components/ProjectKeyInformation";
import { EntityInCharge } from "../components/EntityInCharge";
import { ProjectFinancialData } from "../components/ProjectFinancialData";
import { ProjectDates } from "../components/ProjectDates";
import { RomReview } from "../components/RomReview";
import Button from "@material-ui/core/Button";
import { inject, observer } from "mobx-react";
import { stores } from "../store";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { ProjectSelect } from "../components/ProjectSelect";
import { RomData } from "../components/RomData";

import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';

import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';

import InputAdornment from "@material-ui/core/InputAdornment";
import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import 'moment-timezone';
import moment from 'moment'

import Autocomplete from '@material-ui/lab/Autocomplete';

import NumberFormat from 'react-number-format';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

export class SearchFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            projectList: [],
            typeOfROM: -1,
            typeOfReport: "",
            typeOfReportToShow: "",
            projectTitle: "",
            projectNumber: "",
            status: "",
            sector: "",
            smcsCode: "",
            annualType: -1,
            typeOfProject: "",
            IPAType: "",
            FAType: "",
            FAMAType: "",
            cfcuContractManager: "",
            deuaSectorExpert: "",
            deuaMonitoringExpert: "",
            eudSectorManager: "",
            beneficiaryInstitution: "",
            beneficiaryUnitDepartment: "",
            contractingPartner: "",
            totalBudget: "",
            euContribution: "",
            nationalCoFinancing: "",
            otherCoFinancing: "",
            mainComponentBudget: "",
            totalFundsDisbursed: "",
            //lastDateOfPayment: new Date(),
            //lastDateOfPaymentChanged: false,
            //contractorSignatureDate: new Date(),
            //contractorSignatureDateChanged: false,
            //projectStartDate: new Date(),
            //projectStartDateChanged: false,
            //finalDate: new Date(),
            //finalDateChanged: false,
            reasonfortheRomReview: "",
            //romExpertName: "",
            //coMonitor: "",
            //fieldPhaseStartDate: new Date("01/01/2000"),
            //fieldPhaseStartDateChanged: false,
            //fieldPhaseEndDate: new Date("01/01/2030"),
            //fieldPhaseEndDateChanged: false,
            //fieldPhaseStartDateStart: new Date("01/01/2000"),
            //fieldPhaseStartDateStartChanged: false,
            //fieldPhaseStartDateEnd: new Date("01/01/2030"),
            //fieldPhaseStartDateEndChanged: false,
            //fieldPhaseEndDateStart: new Date("01/01/2000"),
            //fieldPhaseEndDateStartChanged: false,
            //fieldPhaseEndDateEnd: new Date("01/01/2030"),
            //fieldPhaseEndDateEndChanged: false,
            fieldPhaseDateStart: new Date("01/01/2000"),
            fieldPhaseDateStartChanged: false,
            fieldPhaseDateEnd: new Date("01/01/2030"),
            fieldPhaseDateEndChanged: false,
            personName: [],
            //names: [
            //    'Oliver Hansen',
            //    'Van Henry',
            //    'April Tucker',
            //    'Ralph Hubbard',
            //    'Omar Alexander',
            //    'Carlos Abbott',
            //    'Miriam Wagner',
            //    'Bradley Wilkerson',
            //    'Virginia Andrews',
            //    'Kelly Snyder',
            //],
            CFCUContractManager: [],
            CFCUContractManagerSelected: [],
            DEUASectorExpert: [],
            DEUASectorExpertSelected: [],
            DEUAMonitoringExpert: [],
            DEUAMonitoringExpertSelected: [],
            EUDSectorManager: [],
            EUDSectorManagerSelected: [],
            BeneficiaryInstitution: [],
            BeneficiaryInstitutionSelected: [],
            BeneficiaryUnitDepartment: [],
            BeneficiaryUnitDepartmentSelected: [],
            ContactAtBeneficiaryInstitution: [],
            ContactAtBeneficiaryInstitutionSelected: [],
            ContractingPartner: [],
            ContractingPartnerSelected: [],
            TeamLeaderPartner: [],
            TeamLeaderPartnerSelected: [],
            totalBudgetMin: "",
            totalBudgetMax: "",
            euContributionMin: "",
            euContributionMax: "",
            nationalCoFinancingMin: "",
            nationalCoFinancingMax: "",
            otherCoFinancingMin: "",
            otherCoFinancingMax: "",
            mainComponentBudgetMin: "",
            mainComponentBudgetMax: "",
            totalFundsDisbursedMin: "",
            totalFundsDisbursedMax: "",

            lastDateOfPaymentStart: new Date("01/01/2000"),
            lastDateOfPaymentStartChanged: false,
            lastDateOfPaymentEnd: new Date("01/01/2030"),
            lastDateOfPaymentEndChanged: false,

            contractorSignatureDateStart: new Date("01/01/2000"),
            contractorSignatureDateStartChanged: false,
            contractorSignatureDateEnd: new Date("01/01/2030"),
            contractorSignatureDateEndChanged: false,

            projectStartDateStart: new Date("01/01/2000"),
            projectStartDateStartChanged: false,
            projectStartDateEnd: new Date("01/01/2030"),
            projectStartDateEndChanged: false,

            finalDateStart: new Date("01/01/2000"),
            finalDateStartChanged: false,
            finalDateEnd: new Date("01/01/2030"),
            finalDateEndChanged: false,

            lastDateOfPaymentStart: new Date("01/01/2000"),
            lastDateOfPaymentStartChanged: false,
            lastDateOfPaymentEnd: new Date("01/01/2030"),
            lastDateOfPaymentEndChanged: false,
            romExpertName: [],
            romExpertNameSelected: [],
            coMonitor: [],
            coMonitorSelected: [],
            Monitors: [],
            MonitorsSelected: [],
            CoMonitorsSelected: [],

            searchFilterData: [],
            isFetching: false,
            isSearchDone: false,
            searchFilterMissionIds: [],
        };
    }

    componentDidMount = async () => {

        let pageTokenAuthData = {
            operation: "AuthCheckToken"
        };

        await fetch(global.variables.API_CHECKTOKEN, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageTokenAuthData)
        })
            .then(response => response.json())
            .then(result => {
                if (result.resultstate > 0 ||
                    result.authresp === 2) {
                    window.location.href = "/login";
                }
            }).catch(() => {
                window.location.href = "/login";
            });

        //let pageData = { operation: "GetListOfProjects" };

        //await this.loadPageProjects();

        //await fetch(global.variables.API_PROJECTDETAILS_GETLISTOFPROJECTS, {
        //    method: "POST",
        //    headers: {
        //        Authorization: "Bearer " + localStorage.getItem("authtoken"),
        //        Accept: "application/json",
        //        "Content-Type": "application/json"
        //    },
        //    body: JSON.stringify(pageData)
        //})
        //    .then(response => response.json())
        //    .then(result => {
        //        console.log(result);

        //        this.setState({ projectList: result.projects });
        //    });

        this.loadPageData();
    };

    loadPageData = async () => {

        let pageData = { operation: "GetSearchFilterPageLoadData" };

        await fetch(global.variables.API_SEARCHFILTER_GETPAGELOADDATA, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(pageData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({
                    CFCUContractManager: result.CFCUContractManager,
                    DEUASectorExpert: result.DEUASectorExpert,
                    DEUAMonitoringExpert: result.DEUAMonitoringExpert,
                    EUDSectorManager: result.EUDSectorManager,
                    BeneficiaryInstitution: result.BeneficiaryInstitution,
                    BeneficiaryUnitDepartment: result.BeneficiaryUnitDepartment,
                    ContactAtBeneficiaryInstitution: result.ContactAtBeneficiaryInstitution,
                    ContractingPartner: result.ContractingPartner,
                    TeamLeaderPartner: result.TeamLeaderPartner,
                    Monitors: result.Monitors
                });
            });
    }

    //createProject = async () => {
    //    //toast.success("Create Project!", {
    //    //    position: toast.POSITION.BOTTOM_RIGHT
    //    //});

    //    await fetch(global.variables.API_CREATEPROJECT, {
    //        method: "POST",
    //        headers: {
    //            Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //            Accept: "application/json",
    //            "Content-Type": "application/json"
    //        },
    //        body: JSON.stringify(this.state)
    //    })
    //        .then(response => response.json())
    //        .then(result => {
    //            console.log(result);

    //            if (result.resultstate === 0) {
    //                toast.success("Create Project Success!", {
    //                    position: toast.POSITION.BOTTOM_RIGHT
    //                });
    //            } else {
    //                toast.error("Create Project Failed!", {
    //                    position: toast.POSITION.BOTTOM_RIGHT
    //                });
    //            }
    //        });
    //};

    //handletypeOfROMSelectChange = async (e, v) => {
    //    e.persist();

    //    if (v !== undefined & v !== null) {
    //        await this.setState({ typeOfROM: v.TypeId });
    //    } else {
    //        await await this.setState({ typeOfROM: -1 });
    //    }

    //    console.log(e.target.name + ": " + e.target.value);
    //    console.log(this.state);
    //}

    handletypeOfROMSelectChange = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    handleChange = async (e) => {
        e.persist();
        await this.setState({ [e.target.name]: e.target.value });
    };

    handleChangeDate = (name, value) => {
        //this.setState({
        //    [name]: new Date(value),
        //    [name + "Changed"]: true
        //});
        this.setState({
            [name]: new Date(moment(value).format('YYYY-MM-DD')),
            [name + "Changed"]: true
        });
        //this.setState({ [name]: new Date(moment(value).format('YYYY-MM-DD')) });
    };

    //handleProjectSelectChange = async (e, v) => {
    //    e.persist();

    //    //console.log(e.target.idProjectDetails);

    //    if (v !== undefined & v !== null) {
    //        //if (v !== null) {
    //        await this.setState({ selectedprojectid: v.idProjectDetails });
    //        //    //console.log(" :: " + e.target.name + " " + e.target.value + " " + v.idProjectDetails + " " + e.target.textContent);

    //        //    //for (var propertyKey in v) {
    //        //    //    console.log(v + " " + propertyKey + " " + v[propertyKey]);
    //        //    //}

    //        //await this.loadPageBeneficiaries();
    //        //await this.loadPageMONQC();
    //    } else {
    //        await this.setState({
    //            selectedprojectid: -1,
    //            beneficiaries: [],
    //            projectMonitor: null,
    //            projectQualityController: null,
    //        });
    //    }
    //}

    handleSelectChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };

    handleAutocompleteChange = (name, value) => {
        console.log(name)
        console.log(value)

        this.setState({ [name]: value });
    };

    handleSelectChangeNullControl = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    handleSelectChangeWithValue = async (e, v, vname) => {
        e.persist();

        if (v !== undefined & v !== null) {
            await this.setState({ [vname]: v.TypeId });
        } else {
            await this.setState({ [vname]: -1 });
        }

        //console.log(vname + ": " + e.target.value);
        console.log(this.state);
    }

    //handleSelectChangeMultiple = event => {
    //    var value = [];

    //    const { options } = event.target;

    //    //console.log(event.target);

    //    //for (let i = 0; i < options.length; i++) {
    //    //    console.log("val: " + options[i].value);
    //    //    if (options[i].selected) {
    //    //        console.log("if entered " + i);
    //    //        value.push(options[i].value);
    //    //    }
    //    //}

    //    console.log("Multiple Value: " + event.target.name + " " + event.target.value + " " + value);

    //    //setPersonName(value);
    //    this.state.personName = value;
    //};

    //handletypeOfROMSelectChange = async (e, v) => {
    //    e.persist();

    //    if (v !== undefined & v !== null) {
    //        await this.setState({ typeOfROM: v.TypeId });
    //    } else {
    //        await this.setState({ typeOfROM: -1 });
    //    }

    //    console.log(e.target.name + ": " + e.target.value);
    //    console.log(this.state);
    //}

    //createMission = async () => {

    //    console.log(this.state);

    //    //toast.success("Create Mission!", {
    //    //    position: toast.POSITION.BOTTOM_RIGHT
    //    //});

    //    await fetch(global.variables.API_CREATEMISSION, {
    //        method: "POST",
    //        headers: {
    //            Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //            Accept: "application/json",
    //            "Content-Type": "application/json"
    //        },
    //        body: JSON.stringify(this.state)
    //    })
    //        .then(response => response.json())
    //        .then(result => {
    //            console.log(result);

    //            if (result.resultstate === 0) {
    //                toast.success("Create Mission Success!", {
    //                    position: toast.POSITION.BOTTOM_RIGHT
    //                });
    //            } else {
    //                toast.error("Create Mission Failed!", {
    //                    position: toast.POSITION.BOTTOM_RIGHT
    //                });
    //            }
    //        });
    //};

    //loadPageProjects = async () => {
    //    let pageData = { operation: "GetListOfProjects" };

    //    await fetch(global.variables.API_PROJECTDETAILS_GETLISTOFPROJECTS, {
    //        method: "POST",
    //        headers: {
    //            Authorization: "Bearer " + localStorage.getItem("authtoken"),
    //            Accept: "application/json",
    //            "Content-Type": "application/json"
    //        },
    //        body: JSON.stringify(pageData)
    //    })
    //        .then(response => response.json())
    //        .then(result => {
    //            console.log(result);

    //            this.setState({ projects: result.projects });
    //        });
    //}

    searchAndFilter = async (e) => {

        if (this.state.typeOfReport === "" || this.state.typeOfReport === -1) {
            toast.error("You must select a type of report.", {
                position: toast.POSITION.BOTTOM_RIGHT
            });

            return;
        }

        if (this.state.contractorSignatureDateStart > this.state.contractorSignatureDateEnd ||
            this.state.projectStartDateStart > this.state.projectStartDateEnd ||
            this.state.finalDateStart > this.state.finalDateEnd ||
            //this.state.fieldPhaseStartDate > this.state.fieldPhaseEndDate
            //this.state.fieldPhaseStartDateStart > this.state.fieldPhaseStartDateEnd ||
            //this.state.fieldPhaseEndDateStart > this.state.fieldPhaseEndDateEnd
            this.state.fieldPhaseDateStart > this.state.fieldPhaseDateEnd
        ) {
            toast.error("Start of a date cannot be after end of the date.", {
                position: toast.POSITION.BOTTOM_RIGHT
            });

            return;
        }

        await this.setState({ isFetching: true });

        console.log(this.state);

        var searchFilterIdsArray = [];

        await fetch(global.variables.API_SEARCHFILTER_ACTIONSEARCHANDFILTER, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(this.state)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                this.setState({ searchFilterData: result.searchdata });

                if (result.searchdata !== undefined) {
                    var i;
                    for (i = 0; i < result.searchdata.length; i++) {
                        searchFilterIdsArray.push(result.searchdata[i].idMissionDetails);
                    }

                    console.log(searchFilterIdsArray);

                    this.setState({ searchFilterMissionIds: searchFilterIdsArray });

                    if (result.searchdata.length <= 0) {
                        console.log("No results returned");

                        toast.info("No entry found", {
                            position: toast.POSITION.BOTTOM_RIGHT
                        });

                        this.setState({ isSearchDone: false });
                    } else {
                        this.setState({ isSearchDone: true });
                    }
                }

            });

        this.setState({ typeOfReportToShow: this.state.typeOfReport });

        await this.setState({ isFetching: false });
    };

    generateReport = async (e) => {

        await this.setState({ isFetching: true });

        //let pageData = {
        //    operation: "CalculateScore",
        //    missionId: 30,
        //    templateId: 3
        //};

        //await fetch(global.variables.API_SEARCHFILTER_CALCULATESCORE, {
        //    method: "POST",
        //    headers: {
        //        Authorization: "Bearer " + localStorage.getItem("authtoken"),
        //        Accept: "application/json",
        //        "Content-Type": "application/json"
        //    },
        //    body: JSON.stringify(pageData)
        //})
        //    .then(response => response.json())
        //    .then(result => {
        //        console.log(result);

        //        if (result.resultstate === 0) {
        //            toast.success("Success!", {
        //                position: toast.POSITION.BOTTOM_RIGHT
        //            });
        //        } else {
        //            toast.error("Failed!", {
        //                position: toast.POSITION.BOTTOM_RIGHT
        //            });
        //        }

        //        //this.setState({ searchFilterData: result.searchdata });
        //    });


        let reportData = {
            operation: "GenerateAndDownloadMonitoringReportTemplate",
            searchAndFilterIdsArray: this.state.searchFilterMissionIds,
            typeOfReport: this.state.typeOfReport,
            //searchAndFilterIdsArray: [1, 2, 3, 4, 5]
        }

        await fetch(global.variables.API_FILEUPLOADDOWNLOAD_GENERATEMONITORINGREPORTTEMPLATE, {
            method: "POST",
            headers: {
                Authorization: "Bearer " + localStorage.getItem("authtoken"),
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            body: JSON.stringify(reportData)
        })
            .then(response => response.json())
            .then(result => {
                console.log(result);

                //return result;

                var a = document.createElement('a');
                //a.href = 'data:attachment/xlsx,' + encodeURI(result);
                //a.href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + encodeURI(result);
                //a.href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,' + result;
                a.href = '/api/FileUploadDownload/DownloadMonitoringReportTemplate/' + btoa(localStorage.getItem("authtoken")) + '/' + result.downloadfilename;
                //a.href = encodeURI(result);
                ////a.target = '_blank';
                a.download = result.filename;
                console.log(a);
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);

                //if (result.resultstate === 0) {
                //    toast.success("Success!", {
                //        position: toast.POSITION.BOTTOM_RIGHT
                //    });
                //} else {
                //    toast.error("Failed!", {
                //        position: toast.POSITION.BOTTOM_RIGHT
                //    });
                //}

                //this.setState({ searchFilterData: result.searchdata });
            });

        //await fetch(global.variables.API_SEARCHFILTER_ACTIONSEARCHANDFILTER, {
        //    method: "POST",
        //    headers: {
        //        Authorization: "Bearer " + localStorage.getItem("authtoken"),
        //        Accept: "application/json",
        //        "Content-Type": "application/json"
        //    },
        //    body: JSON.stringify(this.state)
        //})
        //    .then(response => response.json())
        //    .then(result => {
        //        console.log(result);

        //        if (result.resultstate === 0) {
        //            toast.success("Success!", {
        //                position: toast.POSITION.BOTTOM_RIGHT
        //            });
        //        } else {
        //            toast.error("Failed!", {
        //                position: toast.POSITION.BOTTOM_RIGHT
        //            });
        //        }

        //        this.setState({ searchFilterData: result.searchdata });
        //    });

        await this.setState({ isFetching: false });
    };

    returnArrayElement = (array, element) => {
        for (var i = 0; i < array.length; i++) {
            if (array[i].TypeId == element) {
                return array[i];
            }
        }
        return ({ TypeId: "", TypeName: "" });
    };

    render() {

        const {
            projects,
            typeOfROM,
            typeOfReport,
            typeOfReportToShow,
            projectTitle,
            projectNumber,
            status,
            sector,
            smcsCode,
            annualType,
            typeOfProject,
            IPAType,
            FAType,
            FAMAType,
            //cfcuContractManager,
            //deuaSectorExpert,
            //deuaMonitoringExpert,
            //eudSectorManager,
            //beneficiaryInstitution,
            //contractingPartner,
            //totalBudget,
            //euContribution,
            //nationalCoFinancing,
            //otherCoFinancing,
            //totalFundsDisbursed,
            //lastDateOfPayment,
            //contractorSignatureDate,
            //projectStartDate,
            //finalDate,
            reasonfortheRomReview,
            //romExpertName,
            //coMonitor,
            //fieldPhaseStartDate,
            //fieldPhaseEndDate,

            //fieldPhaseStartDateStart,
            //fieldPhaseStartDateEnd,
            //fieldPhaseEndDateStart,
            //fieldPhaseEndDateEnd,

            fieldPhaseDateStart,
            fieldPhaseDateEnd,

            CFCUContractManager,
            CFCUContractManagerSelected,
            DEUASectorExpert,
            DEUASectorExpertSelected,
            DEUAMonitoringExpert,
            DEUAMonitoringExpertSelected,
            EUDSectorManager,
            EUDSectorManagerSelected,
            BeneficiaryInstitution,
            BeneficiaryInstitutionSelected,
            BeneficiaryUnitDepartment,
            BeneficiaryUnitDepartmentSelected,
            ContactAtBeneficiaryInstitution,
            ContactAtBeneficiaryInstitutionSelected,
            ContractingPartner,
            ContractingPartnerSelected,
            TeamLeaderPartner,
            TeamLeaderPartnerSelected,

            totalBudgetMin,
            totalBudgetMax,
            euContributionMin,
            euContributionMax,
            nationalCoFinancingMin,
            nationalCoFinancingMax,
            otherCoFinancingMin,
            otherCoFinancingMax,
            mainComponentBudgetMin,
            mainComponentBudgetMax,
            totalFundsDisbursedMin,
            totalFundsDisbursedMax,

            lastDateOfPaymentStart,
            lastDateOfPaymentEnd,

            contractorSignatureDateStart,
            contractorSignatureDateEnd,
            projectStartDateStart,
            projectStartDateEnd,
            finalDateStart,
            finalDateEnd,

            romExpertName,
            romExpertNameSelected,
            coMonitor,
            coMonitorSelected,

            Monitors,
            MonitorsSelected,
            CoMonitorsSelected,

            searchFilterData,

            //projects,
            //typeOfROM,
            //projectTitle,
            //projectNumber,
            //status,
            //sector,
            //smcsCode,
            //cfcuContractManager,
            //deuaSectorExpert,
            //deuaMonitoringExpert,
            //eudSectorManager,
            //beneficiaryInstitution,
            //contractingPartner,
            //totalBudget,
            //euContribution,
            //nationalCoFinancing,
            //otherCoFinancing,
            //totalFundsDisbursed,
            //lastDateOfPayment,
            //contractorSignatureDate,
            //projectStartDate,
            //finalDate,
            //reasonfortheRomReview,
            //romExpertName,
            //coMonitor,
            //fieldPhaseStartDate,
            //fieldPhaseEndDate

            //personName,
            //names,

            isFetching,
            isSearchDone,

        } = this.state;

        var typeOfReportOptions = [
            { TypeId: 1, TypeName: "Ongoing (Ongoing, Supply Ongoing, Works Ongoing)" },
            { TypeId: 2, TypeName: "Ex-Post (Ex-post, Supply Ex-post, Works Ex-post" },
            { TypeId: 3, TypeName: "List of All Monitored (Both Ongoing and Ex-post)" },
            { TypeId: 4, TypeName: "List of All Projects" },
        ];

        return (
            <div style={{ maxWidth: '100%' }}>
                <Grid container spacing={3} >
                    <Grid>
                        <ToastContainer />
                    </Grid>
                    {
                        //<Grid item xs={6} height="100%">
                        //    <ProjectData
                        //        onChange={this.handleChange}
                        //        //onChangetypeOfROM={this.handletypeOfROMSelectChange}
                        //        //typeOfROM={typeOfROM}
                        //        projectTitle={projectTitle}
                        //        projectNumber={projectNumber}
                        //        //status={status}
                        //    />
                        //</Grid>
                    }

                    <Grid item xs={12} height="100%">
                        <Card>
                            <CardHeader title="Project Number" className='romis-card-header' />
                            <CardContent>
                                <TextField
                                    label="Project Number :"
                                    placeholder="Project Number"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChange.bind(this)}
                                    value={projectNumber}
                                    name="projectNumber"
                                />
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={12} height="100%">
                        <Card>
                            <CardHeader title="Project Title" className='romis-card-header' />
                            <CardContent>
                                <TextField
                                    label="Project Title :"
                                    placeholder="Project Title"
                                    fullWidth
                                    margin="normal"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={this.handleChange.bind(this)}
                                    value={projectTitle}
                                    name="projectTitle"
                                />
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid item xs={6} height="100%">
                        <ProjectKeyInformation
                            onChange={this.handleChange}
                            onSelectChange={this.handleSelectChangeWithValue}
                            sector={sector}
                            smcsCode={smcsCode}
                            annualType={annualType}
                            typeOfProject={typeOfProject}
                            IPAType={IPAType}
                            FAType={FAType}
                            FAMAType={FAMAType}
                            userType={2} // Force Enable Edit Access
                        />
                    </Grid>

                    <Grid item xs={6} height="100%">
                        {
                            //<EntityInCharge
                            //    onChange={this.handleChange}
                            //    cfcuContractManager={cfcuContractManager}
                            //    deuaSectorExpert={deuaSectorExpert}
                            //    deuaMonitoringExpert={deuaMonitoringExpert}
                            //    eudSectorManager={eudSectorManager}
                            //    beneficiaryInstitution={beneficiaryInstitution}
                            //    contractingPartner={contractingPartner}
                            ///>
                        }

                        <Card>
                            <CardHeader title="Entity In Charge" className='romis-card-header' />
                            <CardContent>
                                {
                                    //<FormControl fullWidth style={{ margin: "1px 1px 1px 1px", minWidth: 120, maxWidth: 300 }}>
                                }
                                <FormControl fullWidth>
                                    <Autocomplete
                                        name="CFCUContractManagerSelected"
                                        options={CFCUContractManager}
                                        getOptionLabel={option => option}
                                        autoComplete
                                        multiple
                                        includeInputInList
                                        onChange={(e, v) => this.handleAutocompleteChange("CFCUContractManagerSelected", v)}
                                        value={CFCUContractManagerSelected}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label="CFCU Contract Manager Name"
                                                placeholder="Select Manager"
                                                fullWidth
                                                margin="normal"
                                            />
                                        )}
                                    />
                                </FormControl>

                                <FormControl fullWidth>
                                    <Autocomplete
                                        name="DEUASectorExpertSelected"
                                        options={DEUASectorExpert}
                                        getOptionLabel={option => option}
                                        autoComplete
                                        multiple
                                        includeInputInList
                                        onChange={(e, v) => this.handleAutocompleteChange("DEUASectorExpertSelected", v)}
                                        value={DEUASectorExpertSelected}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label="DEUA Sector Expert"
                                                placeholder="Select Sector Expert"
                                                fullWidth
                                                margin="normal"
                                            />
                                        )}
                                    />
                                </FormControl>

                                <FormControl fullWidth>
                                    <Autocomplete
                                        name="DEUAMonitoringExpertSelected"
                                        options={DEUAMonitoringExpert}
                                        getOptionLabel={option => option}
                                        autoComplete
                                        multiple
                                        includeInputInList
                                        onChange={(e, v) => this.handleAutocompleteChange("DEUAMonitoringExpertSelected", v)}
                                        value={DEUAMonitoringExpertSelected}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label="DEUA Monitoring Expert"
                                                placeholder="Select Monitoring Expert"
                                                fullWidth
                                                margin="normal"
                                            />
                                        )}
                                    />
                                </FormControl>

                                <FormControl fullWidth>
                                    <Autocomplete
                                        name="EUDSectorManagerSelected"
                                        options={EUDSectorManager}
                                        getOptionLabel={option => option}
                                        autoComplete
                                        multiple
                                        includeInputInList
                                        onChange={(e, v) => this.handleAutocompleteChange("EUDSectorManagerSelected", v)}
                                        value={EUDSectorManagerSelected}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label="EUD Sector Manager"
                                                placeholder="Select Sector Manager"
                                                fullWidth
                                                margin="normal"
                                            />
                                        )}
                                    />
                                </FormControl>

                                <FormControl fullWidth>
                                    <Autocomplete
                                        name="BeneficiaryInstitutionSelected"
                                        options={BeneficiaryInstitution}
                                        getOptionLabel={option => option}
                                        autoComplete
                                        multiple
                                        includeInputInList
                                        onChange={(e, v) => this.handleAutocompleteChange("BeneficiaryInstitutionSelected", v)}
                                        value={BeneficiaryInstitutionSelected}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label="Beneficiary Institution"
                                                placeholder="Select Institution"
                                                fullWidth
                                                margin="normal"
                                            />
                                        )}
                                    />
                                </FormControl>

                                <FormControl fullWidth>
                                    <Autocomplete
                                        name="BeneficiaryUnitDepartmentSelected"
                                        options={BeneficiaryUnitDepartment}
                                        getOptionLabel={option => option}
                                        autoComplete
                                        multiple
                                        includeInputInList
                                        onChange={(e, v) => this.handleAutocompleteChange("BeneficiaryUnitDepartmentSelected", v)}
                                        value={BeneficiaryUnitDepartmentSelected}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label="Beneficiary Unit / Department"
                                                placeholder="Select Unit / Department"
                                                fullWidth
                                                margin="normal"
                                            />
                                        )}
                                    />
                                </FormControl>

                                <FormControl fullWidth>
                                    <Autocomplete
                                        name="ContactAtBeneficiaryInstitutionSelected"
                                        options={ContactAtBeneficiaryInstitution}
                                        getOptionLabel={option => option}
                                        autoComplete
                                        multiple
                                        includeInputInList
                                        onChange={(e, v) => this.handleAutocompleteChange("ContactAtBeneficiaryInstitutionSelected", v)}
                                        value={ContactAtBeneficiaryInstitutionSelected}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label="Contact at Beneficiary Inst."
                                                placeholder="Select"
                                                fullWidth
                                                margin="normal"
                                            />
                                        )}
                                    />
                                </FormControl>

                                <FormControl fullWidth>
                                    <Autocomplete
                                        name="ContractingPartnerSelected"
                                        options={ContractingPartner}
                                        getOptionLabel={option => option}
                                        autoComplete
                                        multiple
                                        includeInputInList
                                        onChange={(e, v) => this.handleAutocompleteChange("ContractingPartnerSelected", v)}
                                        value={ContractingPartnerSelected}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label="Contracting Partner"
                                                placeholder="Select"
                                                fullWidth
                                                margin="normal"
                                            />
                                        )}
                                    />
                                </FormControl>

                                <FormControl fullWidth>
                                    <Autocomplete
                                        name="TeamLeaderPartnerSelected"
                                        options={TeamLeaderPartner}
                                        getOptionLabel={option => option}
                                        autoComplete
                                        multiple
                                        includeInputInList
                                        onChange={(e, v) => this.handleAutocompleteChange("TeamLeaderPartnerSelected", v)}
                                        value={TeamLeaderPartnerSelected}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label="Team Leader / RTA at Partner"
                                                placeholder="Select"
                                                fullWidth
                                                margin="normal"
                                            />
                                        )}
                                    />
                                </FormControl>

                                {
                                    //<FormControl fullWidth>
                                    //    <InputLabel id="mutiple-name-label">Test</InputLabel>
                                    //    <Select
                                    //        name="personName"
                                    //        labelId="mutiple-name-label"
                                    //        id="mutiple-name"
                                    //        multiple
                                    //        value={personName}
                                    //        onChange={this.handleSelectChange.bind(this)}
                                    //        input={<Input />}
                                    //        MenuProps={MenuProps}
                                    //    >
                                    //        {names.map(name => (
                                    //            <MenuItem key={name} value={name} style={{ fontWeight: personName.indexOf(name) === -1 ? "normal" : "bold" }}>
                                    //                {name}
                                    //            </MenuItem>
                                    //        ))}
                                    //    </Select>
                                    //</FormControl>

                                    //<TextField
                                    //    label="CFCU Contract Manager :"
                                    //    placeholder="CFCU Contract Manager"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true,
                                    //    }}
                                    //    onChange={this.handleChange}
                                    //    value={cfcuContractManager}
                                    //    name="cfcuContractManager"

                                    ///>

                                    //<TextField
                                    //    label="DEUA Sector Expert :"
                                    //    placeholder="DEUA Sector Expert"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true,
                                    //    }}
                                    //    onChange={this.handleChange}
                                    //    value={deuaSectorExpert}
                                    //    name="deuaSectorExpert"

                                    ///>
                                    //<TextField
                                    //    label="DEUA Monitoring Expert :"
                                    //    placeholder="DEUA Monitoring Expert"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true,
                                    //    }}
                                    //    onChange={this.handleChange}
                                    //    value={deuaMonitoringExpert}
                                    //    name="deuaMonitoringExpert"
                                    ///>
                                    //<TextField
                                    //    label="EUD Sector Manager :"
                                    //    placeholder="EUD Sector Manager"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true,
                                    //    }}
                                    //    onChange={this.handleChange}
                                    //    value={eudSectorManager}
                                    //    name="eudSectorManager"
                                    ///>
                                    //<TextField
                                    //    label="Beneficiary Institution :"
                                    //    placeholder="Beneficiary Institution"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true,
                                    //    }}
                                    //    onChange={this.handleChange}
                                    //    value={beneficiaryInstitution}
                                    //    name="beneficiaryInstitution"

                                    ///>
                                    //<TextField
                                    //    label="Contracting Partner :"
                                    //    placeholder="Contracting Partner"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true,
                                    //    }}
                                    //    onChange={this.handleChange}
                                    //    value={contractingPartner}
                                    //    name="contractingPartner"

                                    ///>
                                }
                            </CardContent>

                        </Card>


                    </Grid>
                    <Grid item xs={6} height="100%">
                        {
                            //<ProjectFinancialData
                            //    onChange={this.handleChange}
                            //    onChangeDate={(name, value) =>
                            //        this.handleChangeDate(name, value)
                            //    }
                            //    totalBudget={totalBudget}
                            //    euContribution={euContribution}
                            //    nationalCoFinancing={nationalCoFinancing}
                            //    otherCoFinancing={otherCoFinancing}
                            //    totalFundsDisbursed={totalFundsDisbursed}
                            //    lastDateOfPayment={lastDateOfPayment}
                            ///>
                        }
                        <Card>
                            <CardHeader
                                title="Project Financial Data"
                                className="romis-card-header"
                            />
                            <CardContent>

                                <Grid container spacing={3} >
                                    <Grid item xs={6} height="100%">

                                        <NumberFormat
                                            customInput={TextField}
                                            thousandSeparator=","
                                            decimalSeparator="."
                                            label="Total Budget Min :"
                                            placeholder="Total Budget Min"
                                            fullWidth
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">€</InputAdornment>
                                            }}
                                            onChange={this.handleChange}
                                            value={totalBudgetMin}
                                            name="totalBudgetMin"
                                        />

                                        {
                                            //<TextField
                                            //    label="Total Budget Min :"
                                            //    placeholder="Total Budget Min"
                                            //    fullWidth
                                            //    margin="normal"
                                            //    InputLabelProps={{
                                            //        shrink: true
                                            //    }}
                                            //    //InputProps={{
                                            //    //    endAdornment: <InputAdornment position="end">�</InputAdornment>
                                            //    //}}
                                            //    onChange={this.handleChange}
                                            //    value={totalBudgetMin}
                                            //    name="totalBudgetMin"
                                            ///>
                                        }

                                    </Grid>

                                    <Grid item xs={6} height="100%">

                                        <NumberFormat
                                            customInput={TextField}
                                            thousandSeparator=","
                                            decimalSeparator="."
                                            label="Total Budget Max :"
                                            placeholder="Total Budget Max"
                                            fullWidth
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">€</InputAdornment>
                                            }}
                                            onChange={this.handleChange}
                                            value={totalBudgetMax}
                                            name="totalBudgetMax"
                                        />

                                        {
                                            //<TextField
                                            //    label="Total Budget Max :"
                                            //    placeholder="Total Budget Max"
                                            //    fullWidth
                                            //    margin="normal"
                                            //    InputLabelProps={{
                                            //        shrink: true
                                            //    }}
                                            //    //InputProps={{
                                            //    //    endAdornment: <InputAdornment position="end">�</InputAdornment>
                                            //    //}}
                                            //    onChange={this.handleChange}
                                            //    value={totalBudgetMax}
                                            //    name="totalBudgetMax"
                                            ///>
                                        }

                                    </Grid>
                                </Grid>


                                <Grid container spacing={3} >
                                    <Grid item xs={6} height="100%">

                                        <NumberFormat
                                            customInput={TextField}
                                            thousandSeparator=","
                                            decimalSeparator="."
                                            label="EU Contribution Min :"
                                            placeholder="EU Contribution Min "
                                            fullWidth
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">€</InputAdornment>
                                            }}
                                            onChange={this.handleChange}
                                            value={euContributionMin}
                                            name="euContributionMin"
                                        />

                                        {
                                            //<TextField
                                            //    label="EU Contribution Min :"
                                            //    placeholder="EU Contribution Min "
                                            //    fullWidth
                                            //    margin="normal"
                                            //    InputLabelProps={{
                                            //        shrink: true
                                            //    }}
                                            //    //InputProps={{
                                            //    //    endAdornment: <InputAdornment position="end">�</InputAdornment>
                                            //    //}}
                                            //    onChange={this.handleChange}
                                            //    value={euContributionMin}
                                            //    name="euContributionMin"
                                            ///>
                                        }

                                    </Grid>
                                    <Grid item xs={6} height="100%">

                                        <NumberFormat
                                            customInput={TextField}
                                            thousandSeparator=","
                                            decimalSeparator="."
                                            label="EU Contribution Max :"
                                            placeholder="EU Contribution Max "
                                            fullWidth
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">€</InputAdornment>
                                            }}
                                            onChange={this.handleChange}
                                            value={euContributionMax}
                                            name="euContributionMax"
                                        />

                                        {
                                            //<TextField
                                            //    label="EU Contribution Max :"
                                            //    placeholder="EU Contribution Max "
                                            //    fullWidth
                                            //    margin="normal"
                                            //    InputLabelProps={{
                                            //        shrink: true
                                            //    }}
                                            //    //InputProps={{
                                            //    //    endAdornment: <InputAdornment position="end">�</InputAdornment>
                                            //    //}}
                                            //    onChange={this.handleChange}
                                            //    value={euContributionMax}
                                            //    name="euContributionMax"
                                            ///>
                                        }

                                    </Grid>
                                </Grid>

                                <Grid container spacing={3} >
                                    <Grid item xs={6} height="100%">


                                        <NumberFormat
                                            customInput={TextField}
                                            thousandSeparator=","
                                            decimalSeparator="."
                                            label="National Co-Financing Min :"
                                            placeholder="National Co-Financing Min "
                                            fullWidth
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">€</InputAdornment>
                                            }}
                                            onChange={this.handleChange}
                                            value={nationalCoFinancingMin}
                                            name="nationalCoFinancingMin"
                                        />

                                        {
                                            //<TextField
                                            //    label="National Co-Financing Min :"
                                            //    placeholder="National Co-Financing Min "
                                            //    fullWidth
                                            //    margin="normal"
                                            //    InputLabelProps={{
                                            //        shrink: true
                                            //    }}
                                            //    //InputProps={{
                                            //    //    endAdornment: <InputAdornment position="end">�</InputAdornment>
                                            //    //}}
                                            //    onChange={this.handleChange}
                                            //    value={nationalCoFinancingMin}
                                            //    name="nationalCoFinancingMin"
                                            ///>
                                        }

                                    </Grid>
                                    <Grid item xs={6} height="100%">

                                        <NumberFormat
                                            customInput={TextField}
                                            thousandSeparator=","
                                            decimalSeparator="."
                                            label="National Co-Financing Max :"
                                            placeholder="National Co-Financing Max "
                                            fullWidth
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">€</InputAdornment>
                                            }}
                                            onChange={this.handleChange}
                                            value={nationalCoFinancingMax}
                                            name="nationalCoFinancingMax"
                                        />

                                        {
                                            //<TextField
                                            //    label="National Co-Financing Max :"
                                            //    placeholder="National Co-Financing Max "
                                            //    fullWidth
                                            //    margin="normal"
                                            //    InputLabelProps={{
                                            //        shrink: true
                                            //    }}
                                            //    //InputProps={{
                                            //    //    endAdornment: <InputAdornment position="end">�</InputAdornment>
                                            //    //}}
                                            //    onChange={this.handleChange}
                                            //    value={nationalCoFinancingMax}
                                            //    name="nationalCoFinancingMax"
                                            ///>
                                        }

                                    </Grid>
                                </Grid>
                                <Grid container spacing={3} >
                                    <Grid item xs={6} height="100%">

                                        <NumberFormat
                                            customInput={TextField}
                                            thousandSeparator=","
                                            decimalSeparator="."
                                            label="Other Co-Financing Min :"
                                            placeholder="Other Co-Financing Min"
                                            fullWidth
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">€</InputAdornment>
                                            }}
                                            onChange={this.handleChange}
                                            value={otherCoFinancingMin}
                                            name="otherCoFinancingMin"
                                        />

                                        {
                                            //<TextField
                                            //    label="Other Co-Financing Min :"
                                            //    placeholder="Other Co-Financing Min"
                                            //    fullWidth
                                            //    margin="normal"
                                            //    InputLabelProps={{
                                            //        shrink: true
                                            //    }}
                                            //    //InputProps={{
                                            //    //    endAdornment: <InputAdornment position="end">�</InputAdornment>
                                            //    //}}
                                            //    onChange={this.handleChange}
                                            //    value={otherCoFinancingMin}
                                            //    name="otherCoFinancingMin"
                                            ///>
                                        }

                                    </Grid>
                                    <Grid item xs={6} height="100%">

                                        <NumberFormat
                                            customInput={TextField}
                                            thousandSeparator=","
                                            decimalSeparator="."
                                            label="Other Co-Financing Max :"
                                            placeholder="Other Co-Financing Max "
                                            fullWidth
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">€</InputAdornment>
                                            }}
                                            onChange={this.handleChange}
                                            value={otherCoFinancingMax}
                                            name="otherCoFinancingMax"
                                        />

                                        {
                                            //<TextField
                                            //    label="Other Co-Financing Max :"
                                            //    placeholder="Other Co-Financing Max "
                                            //    fullWidth
                                            //    margin="normal"
                                            //    InputLabelProps={{
                                            //        shrink: true
                                            //    }}
                                            //    //InputProps={{
                                            //    //    endAdornment: <InputAdornment position="end">�</InputAdornment>
                                            //    //}}
                                            //    onChange={this.handleChange}
                                            //    value={otherCoFinancingMax}
                                            //    name="otherCoFinancingMax"
                                            ///>
                                        }

                                    </Grid>
                                </Grid>
                                <Grid container spacing={3} >
                                    <Grid item xs={6} height="100%">

                                        <NumberFormat
                                            customInput={TextField}
                                            thousandSeparator=","
                                            decimalSeparator="."
                                            label="Main Comp. Budget Min :"
                                            placeholder="Main Component Budget Min"
                                            fullWidth
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">€</InputAdornment>
                                            }}
                                            onChange={this.handleChange}
                                            value={mainComponentBudgetMin}
                                            name="mainComponentBudgetMin"
                                        />

                                        {
                                            //<TextField
                                            //    label="Main Comp. Budget Min :"
                                            //    placeholder="Main Component Budget Min"
                                            //    fullWidth
                                            //    margin="normal"
                                            //    InputLabelProps={{
                                            //        shrink: true
                                            //    }}
                                            //    //InputProps={{
                                            //    //    endAdornment: <InputAdornment position="end">�</InputAdornment>
                                            //    //}}
                                            //    onChange={this.handleChange}
                                            //    value={mainComponentBudgetMin}
                                            //    name="mainComponentBudgetMin"
                                            ///>
                                        }

                                    </Grid>
                                    <Grid item xs={6} height="100%">

                                        <NumberFormat
                                            customInput={TextField}
                                            thousandSeparator=","
                                            decimalSeparator="."
                                            label="Main Comp. Budget Max :"
                                            placeholder="Main Component Budget Max "
                                            fullWidth
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">€</InputAdornment>
                                            }}
                                            onChange={this.handleChange}
                                            value={mainComponentBudgetMax}
                                            name="mainComponentBudgetMax"
                                        />

                                        {
                                            //<TextField
                                            //    label="Main Comp. Budget Max :"
                                            //    placeholder="Main Component Budget Max "
                                            //    fullWidth
                                            //    margin="normal"
                                            //    InputLabelProps={{
                                            //        shrink: true
                                            //    }}
                                            //    //InputProps={{
                                            //    //    endAdornment: <InputAdornment position="end">�</InputAdornment>
                                            //    //}}
                                            //    onChange={this.handleChange}
                                            //    value={mainComponentBudgetMax}
                                            //    name="mainComponentBudgetMax"
                                            ///>
                                        }

                                    </Grid>
                                </Grid>
                                <Grid container spacing={3} >
                                    <Grid item xs={6} height="100%">

                                        <NumberFormat
                                            customInput={TextField}
                                            thousandSeparator=","
                                            decimalSeparator="."
                                            label="Total Funds Disbursed Min :"
                                            placeholder="Total Funds Disbursed Min "
                                            fullWidth
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">€</InputAdornment>
                                            }}
                                            onChange={this.handleChange}
                                            value={totalFundsDisbursedMin}
                                            name="totalFundsDisbursedMin"
                                        />

                                        {
                                            //<TextField
                                            //    label="Total Funds Disbursed Min :"
                                            //    placeholder="Total Funds Disbursed Min "
                                            //    fullWidth
                                            //    margin="normal"
                                            //    InputLabelProps={{
                                            //        shrink: true
                                            //    }}
                                            //    //InputProps={{
                                            //    //    endAdornment: <InputAdornment position="end">�</InputAdornment>
                                            //    //}}
                                            //    onChange={this.handleChange}
                                            //    value={totalFundsDisbursedMin}
                                            //    name="totalFundsDisbursedMin"
                                            ///>
                                        }

                                    </Grid>
                                    <Grid item xs={6} height="100%">

                                        <NumberFormat
                                            customInput={TextField}
                                            thousandSeparator=","
                                            decimalSeparator="."
                                            label="Total Funds Disbursed Max :"
                                            placeholder="Total Funds Disbursed Max "
                                            fullWidth
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true
                                            }}
                                            InputProps={{
                                                startAdornment: <InputAdornment position="start">€</InputAdornment>
                                            }}
                                            onChange={this.handleChange}
                                            value={totalFundsDisbursedMax}
                                            name="totalFundsDisbursedMax"
                                        />

                                        {
                                            //<TextField
                                            //    label="Total Funds Disbursed Max :"
                                            //    placeholder="Total Funds Disbursed Max "
                                            //    fullWidth
                                            //    margin="normal"
                                            //    InputLabelProps={{
                                            //        shrink: true
                                            //    }}
                                            //    //InputProps={{
                                            //    //    endAdornment: <InputAdornment position="end">�</InputAdornment>
                                            //    //}}
                                            //    onChange={this.handleChange}
                                            //    value={totalFundsDisbursedMax}
                                            //    name="totalFundsDisbursedMax"
                                            ///>
                                        }

                                    </Grid>
                                </Grid>

                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <Grid container spacing={3} >
                                        <Grid item xs={6} height="100%">
                                            <KeyboardDatePicker
                                                margin="normal"
                                                variant="inline"
                                                label="Last Date Of Payment Start :"
                                                format="dd/MM/yyyy"
                                                fullWidth
                                                onChange={value => {
                                                    this.handleChangeDate("lastDateOfPaymentStart", value);
                                                }}
                                                //value={lastDateOfPayment === "" ? new Date() : lastDateOfPayment}
                                                value={lastDateOfPaymentStart}
                                                name="lastDateOfPaymentStart"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                autoOk
                                            />

                                        </Grid>
                                        <Grid item xs={6} height="100%">
                                            <KeyboardDatePicker
                                                margin="normal"
                                                variant="inline"
                                                label="Last Date Of Payment End :"
                                                format="dd/MM/yyyy"
                                                fullWidth
                                                onChange={value => {
                                                    this.handleChangeDate("lastDateOfPaymentEnd", value);
                                                }}
                                                //value={lastDateOfPayment === "" ? new Date() : lastDateOfPayment}
                                                value={lastDateOfPaymentEnd}
                                                name="lastDateOfPaymentEnd"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                autoOk
                                            />
                                        </Grid>
                                    </Grid>
                                </MuiPickersUtilsProvider>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={6} height="100%">
                        {
                            //<ProjectDates
                            //    onChange={(name, value) => this.handleChangeDate(name, value)}
                            //    contractorSignatureDate={contractorSignatureDate}
                            //    projectStartDate={projectStartDate}
                            //    finalDate={finalDate}
                            ///>
                        }
                        <Card>
                            <CardHeader title="Project Dates" className="romis-card-header" />
                            <CardContent>
                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <Grid container spacing={3} >
                                        <Grid item xs={6} height="100%">
                                            <KeyboardDatePicker
                                                margin="normal"
                                                variant="inline"
                                                label="Cont. Signature Date Start :"
                                                format="dd/MM/yyyy"
                                                fullWidth
                                                onChange={value => {
                                                    this.handleChangeDate("contractorSignatureDateStart", value);
                                                }}
                                                //value={
                                                //  contractorSignatureDate === ""
                                                //    ? new Date()
                                                //    : contractorSignatureDate
                                                //}
                                                value={contractorSignatureDateStart}
                                                name="contractorSignatureDateStart"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                autoOk
                                            />
                                        </Grid>
                                        <Grid item xs={6} height="100%">
                                            <KeyboardDatePicker
                                                margin="normal"
                                                variant="inline"
                                                label="Cont. Signature Date End :"
                                                format="dd/MM/yyyy"
                                                fullWidth
                                                onChange={value => {
                                                    this.handleChangeDate("contractorSignatureDateEnd", value);
                                                }}
                                                //value={
                                                //  contractorSignatureDate === ""
                                                //    ? new Date()
                                                //    : contractorSignatureDate
                                                //}
                                                value={contractorSignatureDateEnd}
                                                name="contractorSignatureDateEnd"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                autoOk
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={3} >
                                        <Grid item xs={6} height="100%">
                                            <KeyboardDatePicker
                                                margin="normal"
                                                variant="inline"
                                                label="Project Start Date Start :"
                                                format="dd/MM/yyyy"
                                                fullWidth
                                                onChange={value => {
                                                    this.handleChangeDate("projectStartDateStart", value);
                                                }}
                                                //value={projectStartDate === "" ? new Date() : projectStartDate}
                                                value={projectStartDateStart}
                                                name="projectStartDateStart"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                autoOk
                                            />
                                        </Grid>
                                        <Grid item xs={6} height="100%">
                                            <KeyboardDatePicker
                                                margin="normal"
                                                variant="inline"
                                                label="Project Start Date End :"
                                                format="dd/MM/yyyy"
                                                fullWidth
                                                onChange={value => {
                                                    this.handleChangeDate("projectStartDateEnd", value);
                                                }}
                                                //value={projectStartDate === "" ? new Date() : projectStartDate}
                                                value={projectStartDateEnd}
                                                name="projectStartDateEnd"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                autoOk
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={3} >
                                        <Grid item xs={6} height="100%">
                                            <KeyboardDatePicker
                                                margin="normal"
                                                variant="inline"
                                                label="Final Date for Impl. Start :"
                                                format="dd/MM/yyyy"
                                                fullWidth
                                                onChange={value => {
                                                    this.handleChangeDate("finalDateStart", value);
                                                }}
                                                //value={finalDate === "" ? new Date() : finalDate}
                                                value={finalDateStart}
                                                name="finalDateStart"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                autoOk
                                            />
                                        </Grid>
                                        <Grid item xs={6} height="100%">
                                            <KeyboardDatePicker
                                                margin="normal"
                                                variant="inline"
                                                label="Final Date for Impl. End :"
                                                format="dd/MM/yyyy"
                                                fullWidth
                                                onChange={value => {
                                                    this.handleChangeDate("finalDateEnd", value);
                                                }}
                                                //value={finalDate === "" ? new Date() : finalDate}
                                                value={finalDateEnd}
                                                name="finalDateEnd"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                autoOk
                                            />
                                        </Grid>
                                    </Grid>
                                </MuiPickersUtilsProvider>
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={6} height="100%">
                        <RomData
                            //onChangetypeOfROM={this.handletypeOfROMSelectChange}
                            onSelectChange={this.handletypeOfROMSelectChange}
                            typeOfROM={typeOfROM}
                            userType={2} // Force Enable Edit Access
                        />
                    </Grid>
                    <Grid item xs={6} height="100%">
                        {
                            //<RomReview
                            //    onChangeDate={(name, value) =>
                            //        this.handleChangeDate(name, value)
                            //    }
                            //    onChange={this.handleChange}
                            //    reasonfortheRomReview={reasonfortheRomReview}
                            //    romExpertName={romExpertName}
                            //    coMonitor={coMonitor}
                            //    fieldPhaseStartDate={fieldPhaseStartDate}
                            //    fieldPhaseEndDate={fieldPhaseEndDate}
                            ///>
                        }
                        <Card>
                            <CardHeader
                                title="Rom Review - Key Information"
                                className="romis-card-header"
                            />
                            <CardContent>
                                {
                                    //<TextField
                                    //    label="Reason for the ROM Review:"
                                    //    placeholder="Reason"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true
                                    //    }}
                                    //    onChange={onChange}
                                    //    value={reasonfortheRomReview}
                                    //    name="reasonfortheRomReview"
                                    ///>
                                }


                                <FormControl fullWidth>
                                    <Autocomplete
                                        name="MonitorsSelected"
                                        options={Monitors}
                                        getOptionLabel={option => option}
                                        autoComplete
                                        multiple
                                        includeInputInList
                                        onChange={(e, v) => this.handleAutocompleteChange("MonitorsSelected", v)}
                                        value={MonitorsSelected}
                                        renderInput={params => (
                                            <TextField
                                                {...params}
                                                label="ROM Monitor"
                                                placeholder="Select"
                                                fullWidth
                                                margin="normal"
                                            />
                                        )}
                                    />
                                </FormControl>

                                {
                                    //<FormControl fullWidth>
                                    //    <Autocomplete
                                    //        name="CoMonitorsSelected"
                                    //        options={Monitors}
                                    //        getOptionLabel={option => option}
                                    //        autoComplete
                                    //        multiple
                                    //        includeInputInList
                                    //        onChange={(e, v) => this.handleAutocompleteChange("CoMonitorsSelected", v)}
                                    //        value={CoMonitorsSelected}
                                    //        renderInput={params => (
                                    //            <TextField
                                    //                {...params}
                                    //                label="CO Monitor"
                                    //                placeholder="Select"
                                    //                fullWidth
                                    //                margin="normal"
                                    //            />
                                    //        )}
                                    //    />
                                    //</FormControl>
                                }

                                {
                                    //<TextField
                                    //    label="ROM Monitor :"
                                    //    placeholder="ROM Monitor"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true
                                    //    }}
                                    //    onChange={this.handleChange}
                                    //    value={romExpertName}
                                    //    name="romExpertName"
                                    ///>

                                    //<TextField
                                    //    label="CO Monitor :"
                                    //    placeholder="CO Monitor"
                                    //    fullWidth
                                    //    margin="normal"
                                    //    InputLabelProps={{
                                    //        shrink: true
                                    //    }}
                                    //    onChange={this.handleChange}
                                    //    value={coMonitor}
                                    //    name="coMonitor"
                                    ///>
                                }

                                {
                                    //<MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    //    <KeyboardDatePicker
                                    //        margin="normal"
                                    //        variant="inline"
                                    //        label="Field Phase Start Date:"
                                    //        format="dd/MM/yyyy"
                                    //        fullWidth
                                    //        onChange={value => {
                                    //            this.handleChangeDate("fieldPhaseStartDate", value);
                                    //        }}
                                    //        //value={
                                    //        //    fieldPhaseStartDate === "" ? new Date() : fieldPhaseStartDate
                                    //        //}
                                    //        value={fieldPhaseStartDate}
                                    //        name="fieldPhaseStartDate"
                                    //        InputLabelProps={{
                                    //            shrink: true
                                    //        }}
                                    //        autoOk
                                    //    />
                                    //</MuiPickersUtilsProvider>
                                }

                                {
                                    //<MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    //    <Grid container spacing={3} >
                                    //        <Grid item xs={6} height="100%">
                                    //            <KeyboardDatePicker
                                    //                margin="normal"
                                    //                variant="inline"
                                    //                label="Field Phase Start Date Start :"
                                    //                format="dd/MM/yyyy"
                                    //                fullWidth
                                    //                onChange={value => {
                                    //                    this.handleChangeDate("fieldPhaseStartDateStart", value);
                                    //                }}
                                    //                //value={projectStartDate === "" ? new Date() : projectStartDate}
                                    //                value={fieldPhaseStartDateStart}
                                    //                name="fieldPhaseStartDateStart"
                                    //                InputLabelProps={{
                                    //                    shrink: true
                                    //                }}
                                    //                autoOk
                                    //            />
                                    //        </Grid>
                                    //        <Grid item xs={6} height="100%">
                                    //            <KeyboardDatePicker
                                    //                margin="normal"
                                    //                variant="inline"
                                    //                label="Field Phase Start Date End :"
                                    //                format="dd/MM/yyyy"
                                    //                fullWidth
                                    //                onChange={value => {
                                    //                    this.handleChangeDate("fieldPhaseStartDateEnd", value);
                                    //                }}
                                    //                //value={projectStartDate === "" ? new Date() : projectStartDate}
                                    //                value={fieldPhaseStartDateEnd}
                                    //                name="fieldPhaseStartDateEnd"
                                    //                InputLabelProps={{
                                    //                    shrink: true
                                    //                }}
                                    //                autoOk
                                    //            />
                                    //        </Grid>
                                    //    </Grid>
                                    //</MuiPickersUtilsProvider>
                                }


                                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    <Grid container spacing={3} >
                                        <Grid item xs={6} height="100%">
                                            <KeyboardDatePicker
                                                margin="normal"
                                                variant="inline"
                                                label="Field Phase Date Start :"
                                                format="dd/MM/yyyy"
                                                fullWidth
                                                onChange={value => {
                                                    this.handleChangeDate("fieldPhaseDateStart", value);
                                                }}
                                                //value={projectStartDate === "" ? new Date() : projectStartDate}
                                                value={fieldPhaseDateStart}
                                                name="fieldPhaseDateStart"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                autoOk
                                            />
                                        </Grid>
                                        <Grid item xs={6} height="100%">
                                            <KeyboardDatePicker
                                                margin="normal"
                                                variant="inline"
                                                label="Field Phase Date End :"
                                                format="dd/MM/yyyy"
                                                fullWidth
                                                onChange={value => {
                                                    this.handleChangeDate("fieldPhaseDateEnd", value);
                                                }}
                                                //value={projectStartDate === "" ? new Date() : projectStartDate}
                                                value={fieldPhaseDateEnd}
                                                name="fieldPhaseDateEnd"
                                                InputLabelProps={{
                                                    shrink: true
                                                }}
                                                autoOk
                                            />
                                        </Grid>
                                    </Grid>
                                </MuiPickersUtilsProvider>


                                {
                                    //<MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    //    <KeyboardDatePicker
                                    //        margin="normal"
                                    //        variant="inline"
                                    //        label="Field Phase End Date:"
                                    //        format="dd/MM/yyyy"
                                    //        fullWidth
                                    //        onChange={value => {
                                    //            this.handleChangeDate("fieldPhaseEndDate", value);
                                    //        }}
                                    //        //value={
                                    //        //    fieldPhaseStartDate === "" ? new Date() : fieldPhaseStartDate
                                    //        //}
                                    //        value={fieldPhaseEndDate}
                                    //        name="fieldPhaseEndDate"
                                    //        InputLabelProps={{
                                    //            shrink: true
                                    //        }}
                                    //        autoOk
                                    //    />
                                    //</MuiPickersUtilsProvider>
                                }

                                {
                                    //<MuiPickersUtilsProvider utils={DateFnsUtils}>
                                    //    <Grid container spacing={3} >
                                    //        <Grid item xs={6} height="100%">
                                    //            <KeyboardDatePicker
                                    //                margin="normal"
                                    //                variant="inline"
                                    //                label="Field Phase End Date Start :"
                                    //                format="dd/MM/yyyy"
                                    //                fullWidth
                                    //                onChange={value => {
                                    //                    this.handleChangeDate("fieldPhaseEndDateStart", value);
                                    //                }}
                                    //                //value={projectStartDate === "" ? new Date() : projectStartDate}
                                    //                value={fieldPhaseEndDateStart}
                                    //                name="fieldPhaseEndDateStart"
                                    //                InputLabelProps={{
                                    //                    shrink: true
                                    //                }}
                                    //                autoOk
                                    //            />
                                    //        </Grid>
                                    //        <Grid item xs={6} height="100%">
                                    //            <KeyboardDatePicker
                                    //                margin="normal"
                                    //                variant="inline"
                                    //                label="Field Phase End Date End :"
                                    //                format="dd/MM/yyyy"
                                    //                fullWidth
                                    //                onChange={value => {
                                    //                    this.handleChangeDate("fieldPhaseEndDateEnd", value);
                                    //                }}
                                    //                //value={projectStartDate === "" ? new Date() : projectStartDate}
                                    //                value={fieldPhaseEndDateEnd}
                                    //                name="fieldPhaseEndDateEnd"
                                    //                InputLabelProps={{
                                    //                    shrink: true
                                    //                }}
                                    //                autoOk
                                    //            />
                                    //        </Grid>
                                    //    </Grid>
                                    //</MuiPickersUtilsProvider>
                                }

                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} height="100%">
                        <Card>
                            <CardHeader
                                title="Type of Report (Selection is mandatory)"
                                className="romis-card-header"
                            />
                            <CardContent>
                                <Autocomplete
                                    options={typeOfReportOptions}
                                    getOptionLabel={option => option.TypeName}
                                    autoComplete
                                    includeInputInList
                                    onChange={(e, v) => this.handleSelectChangeNullControl(e, v, "typeOfReport")}
                                    value={this.returnArrayElement(typeOfReportOptions, typeOfReport)}
                                    renderInput={params => (
                                        <TextField
                                            {...params}
                                            label="Type of Report"
                                            placeholder="Type of Report"
                                            required={true}
                                            fullWidth
                                            margin="normal"
                                        />
                                    )}
                                    required={true}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid>
                        <ToastContainer />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.searchAndFilter.bind(this)}
                            disabled={isFetching ? true : false}
                        >
                            Search & Filter
                        </Button>
                    </Grid>
                    <Grid item xs={12} height="100%">
                        <MaterialTable
                            columns={[
                                { title: 'Project Id', field: 'idProjectDetails', hidden: true },
                                { title: 'Project Number', field: 'ProjectNumber' },
                                { title: 'Project Name', field: 'ProjectTitle' },
                                { title: 'Type of Project', field: 'TypeOfProject' },
                                { title: 'Mission Number', field: 'MissionNumber', hidden: typeOfReportToShow === 4 ? true : false },
                            ]}
                            data={this.state.searchFilterData}
                            title="Search & Filter"
                            actions={typeOfReportToShow === 4 ? [
                                rowData => ({
                                    icon: "info",
                                    tooltip: 'Go to Project',
                                    onClick: (event, rowData) => {
                                        this.props.history.push('/projectdetails/' + rowData.idProjectDetails);
                                    }
                                })

                            ] : [
                                    rowData => ({
                                        //icon: 'info',
                                        //icon: (event, rowData) => {

                                        //    if (rowData !== undefined &&
                                        //        rowData !== null) {

                                        //        if (rowData.revisiondata !== undefined &&
                                        //            rowData.revisiondata !== null) {

                                        //            if (rowData.revisiondata[0].fileMR === "" &&
                                        //                rowData.revisiondata[0].fileNS === "" &&
                                        //                rowData.revisiondata[0].fileNW === "") {
                                        //                return "";
                                        //            } else {
                                        //                return <SystemUpdateAltSharpIcon />
                                        //            }
                                        //        }
                                        //    }
                                        //},
                                        //}
                                        icon: () => typeOfReportToShow === 4 ? "" : <SystemUpdateAltSharpIcon />,
                                        //icon: () => <SystemUpdateAltSharpIcon />,
                                        tooltip: 'Download Report',
                                        onClick: (event, rowData) => {

                                            //if (2 === 1) {

                                            if (rowData.revisiondata !== undefined && rowData.revisiondata !== null) {

                                                var a = document.createElement('a');
                                                //a.href = '/api/FileUploadDownload/DownloadThematicReportTemplate/' + btoa(localStorage.getItem("authtoken")) + '/' + result.downloadfilename;

                                                if (rowData.revisiondata[0].fileMR !== "") {
                                                    //this.props.history.push(`/api/FileUploadDownload/DownloadFileIdWordAsPDF/` + btoa(localStorage.getItem("authtoken")) + `/${rowData.revisiondata[0].fileMR}`);
                                                    a.href = '/api/FileUploadDownload/DownloadFileIdWordAsPDF/' + btoa(localStorage.getItem("authtoken")) + '/' + rowData.revisiondata[0].fileMR;
                                                    a.download = rowData.revisiondata[0].fileMRName;
                                                } else if (rowData.revisiondata[0].fileNS !== "") {
                                                    //this.props.history.push(`/api/FileUploadDownload/DownloadFileIdWordAsPDF/` + btoa(localStorage.getItem("authtoken")) + `/${rowData.revisiondata[0].fileNS}`);
                                                    a.href = '/api/FileUploadDownload/DownloadFileIdWordAsPDF/' + btoa(localStorage.getItem("authtoken")) + '/' + rowData.revisiondata[0].fileNS;
                                                    a.download = rowData.revisiondata[0].fileNSName;
                                                } else if (rowData.revisiondata[0].fileNW !== "") {
                                                    //this.props.history.push(`/api/FileUploadDownload/DownloadFileIdWordAsPDF/` + btoa(localStorage.getItem("authtoken")) + `/${rowData.revisiondata[0].fileNW}`);
                                                    a.href = '/api/FileUploadDownload/DownloadFileIdWordAsPDF/' + btoa(localStorage.getItem("authtoken")) + '/' + rowData.revisiondata[0].fileNW;
                                                    a.download = rowData.revisiondata[0].fileNWName;
                                                }

                                                //a.download = result.filename;
                                                console.log(a);
                                                document.body.appendChild(a);
                                                a.click();
                                                document.body.removeChild(a);
                                            }

                                            //} else {
                                            //    toast.warn("This mission is not yet finalized.", {
                                            //        position: toast.POSITION.BOTTOM_RIGHT
                                            //    });
                                            //}

                                        },
                                        //disabled: (rowData.revisiondata !== undefined &&
                                        //    rowData.revisiondata !== null &&
                                        //    rowData.revisiondata[0] !== undefined &&
                                        //    rowData.revisiondata[0] !== null) &&
                                        //    (rowData.revisiondata[0].fileMR !== null ||
                                        //        rowData.revisiondata[0].fileNS !== null ||
                                        //        rowData.revisiondata[0].fileNW !== null) ? false : true
                                        //disabled: typeOfReport === 4 ? true : false
                                        //disabled: true,
                                    }),

                                    rowData => ({
                                        icon: "info",
                                        tooltip: 'Go to Project',
                                        onClick: (event, rowData) => {
                                            this.props.history.push('/projectdetails/' + rowData.idProjectDetails);
                                        }
                                    })

                                ]}
                            options={{
                                actionsColumnIndex: -1,
                                pageSize: 20
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.generateReport.bind(this)}
                            disabled={!isFetching && isSearchDone ? false : true}
                        >
                            Generate Report
                        </Button>
                        {
                            //<a onClick={this.generateReport.bind(this)} >Generate</a>
                            //<a href="/api/FileUploadDownload/GenerateAndDownloadMonitoringReportTemplate" >Generate2</a>
                        }
                    </Grid>
                </Grid>
            </div >
        );
    }
}




// WEBPACK FOOTER //
// ./src/pages/SearchFilter.js